module.exports = __webpack_public_path__ + "static/img/camo_device_max.b533b4e8.png";